/* ALBEUX PRODUCT PAGE: LENS (Task 2)
   A thin ring that follows the mouse over the product photographs and reads ZOOM (the photographs already open full size on click).
   Mouse screens only; touch screens, small windows and reduced-motion settings are handled. Styling is in albeux-product-lens.css.
   To switch it off, delete the albeux-product-lens.js line in snippets/albeux-fixes.liquid. */
(function () {
  'use strict';
  if (window.__albeuxLens) return;
  window.__albeuxLens = true;

  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
  if (!fine || !fine.matches) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var GRID = "main[data-template^='product'] media-gallery .media-gallery__grid";
  var SKIP = 'button, a, video, input, select, textarea, summary, [role="button"]';

  var lens = null;
  var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0, shown = false;

  function build() {
    if (lens) return lens;
    lens = document.createElement('div');
    lens.className = 'albeux-lens';
    lens.setAttribute('aria-hidden', 'true');
    lens.innerHTML = '<span>Zoom</span>';
    document.body.appendChild(lens);
    return lens;
  }

  function paint() {
    var k = reduce ? 1 : 0.22;
    cx += (tx - cx) * k;
    cy += (ty - cy) * k;
    if (lens) lens.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) translate(-50%,-50%)';
    if (Math.abs(tx - cx) > 0.3 || Math.abs(ty - cy) > 0.3) {
      raf = requestAnimationFrame(paint);
    } else {
      raf = 0;
    }
  }

  function show() {
    if (shown) return;
    shown = true;
    build().classList.add('is-on');
    document.documentElement.classList.add('albeux-lens-on');
  }

  function hide() {
    if (!shown) return;
    shown = false;
    if (lens) lens.classList.remove('is-on');
    document.documentElement.classList.remove('albeux-lens-on');
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target;
    var over = t && t.closest && t.closest(GRID) && !t.closest(SKIP);
    if (!over) { hide(); return; }
    tx = e.clientX;
    ty = e.clientY;
    if (!shown) {
      build();
      cx = tx;
      cy = ty;
    }
    show();
    if (!raf) raf = requestAnimationFrame(paint);
  }, { passive: true });

  document.addEventListener('pointerleave', hide, true);
  window.addEventListener('blur', hide);
  document.addEventListener('visibilitychange', function () { if (document.hidden) hide(); });
  document.addEventListener('click', function (e) {
    // the photograph is opening full size: put the ring away
    if (e.target && e.target.closest && e.target.closest(GRID)) hide();
  }, true);
})();
